import { Box, useTheme } from '@simplywallst/ui-core';

import { CompanyIcon } from '@/components/CompanyIcon';

interface Props {
  name: string;
  url: string | null;
}

export const BrokerageLogo = ({ name, url }: Props) => {
  const theme = useTheme();
  return (
    <Box position="relative">
      <Box
        position="absolute"
        width="40px"
        height="40px"
        top="0"
        left="0"
        style={{
          border: `1px solid ${theme.color.blackRGBA(0.1)}`,
          borderRadius: `${theme.x1spacePx}px`,
        }}
      />

      <CompanyIcon
        tickerSymbol={name.substring(0, 3).toUpperCase()}
        website={url}
        size={40}
      />
    </Box>
  );
};
